// Library imports
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Mui imports
import {
  Container,
  Grid,
  Typography,
  Paper,
  useMediaQuery,
  TextField,
  Select,
  MenuItem,
  SelectChangeEvent,
  FormControl,
  InputLabel,
} from "@mui/material";
import { borderRadius, styled, textAlign, useTheme } from "@mui/system";
import ReactGA from "react-ga4";

// import app components
import AppPrimaryButton from "../../appComponents/buttons/AppPrimaryButton";
import AppVideoPlayer from "../../appComponents/video/AppVideoPlayer";
import stylesBase from "../../styles/styles";

// Import assets
import HomeLogo from "../assets/logo1.png";
// @ts-ignore
import HomeVideo from "../assets/home_video.mp4";
import StartButton from "./StartButton";
import Box from "@mui/material/Box";
import { postDetails } from "../../store/thunks/config.thunk";
import { current } from "@reduxjs/toolkit";

const StyledImage = styled("img")(() => ({
  width: "100%",
  maxWidth: 200,
}));

export default function Greeting() {
  // Detect mobile device for font size fix
  const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const dispatch = useDispatch();
  const [localGreeting, setLocalGreeting] = useState<boolean>(
    localStorage.getItem(`greeting`) === "true" ? true : false
  );

  const matches = useMediaQuery("(min-width:1000px)");

  const theme = useTheme();

  const isMd = useMediaQuery(theme.breakpoints.down("md"));

  // console.log("is xs", isXs);

  const [stage, setStage] = useState<number>(0);

  const [role, setRole] = useState<string>("");

  const [businessUnit, setBusinessUnit] = useState("");

  const handleChange = (event: SelectChangeEvent) => {
    setError(false);
    setBusinessUnit(event.target.value);
  };

  const [error, setError] = useState<boolean>(false);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  return (
    <Box
      component={"div"}
      sx={{
        minHeight: "100vh", // only the wrapper fills the screen
        display: "flex",
        justifyContent: "center", // center horizontally
        alignItems: "center", // center vertically
      }}
    >
      <Container maxWidth={"md"}>
        <Grid
          container
          style={{
            backgroundColor: "#fff",
            padding: stage === 1 && !isMd ? 20 : 10,
            borderRadius: "15px",
            margin: "0 auto", // centers the container horizontally
          }}
          justifyContent="center" // centers items inside horizontally
          alignItems="center" // centers items inside vertically (within the container)
        >
          {stage === 0 && (
            <>
              <Grid
                item
                xs={12}
                // sm={10}
                // md={10}
                // lg={5}
                style={{
                  padding: 10,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <StyledImage
                  src={HomeLogo}
                  alt="Virtual BD logo"
                  style={{
                    height: "70px",

                    maxWidth: "180px",
                  }}
                />
              </Grid>
              {/* <Grid
                item
                xs={12}
                sm={1}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  height: "100%",
                }}
              > */}
              {/* <Box
                  component={"div"}
                  sx={{
                    backgroundColor: "#f26920",
                    color: "#f26920",
                    height: { sm: 250, xs: 2 },
                    width: { sm: 5, xs: "100%" },
                    marginTop: matches ? "0px" : "20px",
                  }}
                ></Box> */}
              {/* </Grid> */}

              <Grid md={10} lg={6} style={{ marginTop: 20 }}>
                <Paper
                  style={{
                    padding: isMobileDevice
                      ? "32px 12px"
                      : matches
                      ? "20px 5px"
                      : "10px 5px",
                    minHeight: isMobileDevice ? "340px" : undefined,
                    opacity: 0.7,
                  }}
                  elevation={0}
                >
                  <Typography
                    variant="h5"
                    align="center"
                    style={{ fontSize: matches ? "1em" : "1.2em" }}
                  >
                    Welcome to this Virtual BD Experience. Please enter your
                    details bellow.
                  </Typography>

                  <TextField
                    label={"Role *"}
                    fullWidth={true}
                    sx={{
                      marginTop: "15px",
                      fontColor: "#686565",
                      fontSize: isMobileDevice ? "16px" : undefined,
                      "& input": {
                        fontSize: isMobileDevice ? "16px" : undefined,
                      },
                    }}
                    value={role}
                    onChange={(e) => {
                      setRole(e.target.value);
                      setError(false);
                    }}
                  />
                  <FormControl fullWidth sx={{ marginTop: "15px" }}>
                    <InputLabel
                      id="demo-simple-select-label"
                      sx={{ fontSize: isMobileDevice ? "16px" : undefined }}
                    >
                      Business Unit <span>*</span>
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={businessUnit}
                      label="Business Unit"
                      onChange={handleChange}
                      sx={{ fontSize: isMobileDevice ? "16px" : undefined }}
                    >
                      <MenuItem value={1}>MS</MenuItem>
                      <MenuItem value={2}>UCC</MenuItem>
                      <MenuItem value={3}>SM</MenuItem>
                      <MenuItem value={4}>SURG</MenuItem>
                      <MenuItem value={5}>MMS</MenuItem>
                      <MenuItem value={6}>PI</MenuItem>
                      <MenuItem value={7}>APM</MenuItem>
                      <MenuItem value={7}>BDx</MenuItem>
                    </Select>
                  </FormControl>
                  {error && (
                    <Typography
                      variant={"subtitle2"}
                      align={"center"}
                      sx={{ color: "red", marginTop: "10px" }}
                    >
                      Please enter your details
                    </Typography>
                  )}
                </Paper>
                <Box
                  component={"div"}
                  style={{
                    // marginTop: 15,
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                  }}
                >
                  {/* <StartButton /> */}
                  <AppPrimaryButton
                    style={{ marginBottom: 20 }}
                    size={"large"}
                    onClick={() => {
                      if (role !== "" && businessUnit !== "") {
                        // localStorage.setItem(`greeting`, `true`);
                        setStage(1);

                        dispatch(
                          postDetails({ role, unit: businessUnit }) as any
                        );
                      } else {
                        setError(true);
                      }
                    }}
                  >
                    Submit
                  </AppPrimaryButton>
                </Box>
              </Grid>
            </>
          )}

          {stage === 1 && (
            <>
              <Grid
                xs={12}
                item
                sx={{ marginBottom: "10px", marginTop: "5px" }}
              >
                <Typography variant="h4" align="center">
                  Hear from Our Team
                </Typography>
              </Grid>
              {/* <Grid
                item
                xs={12}
                sm={10}
                md={5}
                lg={6}
                style={{
                  padding: 10,
                  display: "flex",
                  justifyContent: "center",
                }}
                container
              > */}
              <Grid xs={12} sm={6} item>
                <video
                  src={
                    "https://medias3.digi-sim-api.co.uk/virtus-tech/video/46dcdecf-3b68-4598-97f5-44e15afec6e4/46dcdecf-3b68-4598-97f5-44e15afec6e4.mp4"
                  }
                  style={{
                    width: "100%",
                    borderRadius: "10px",
                  }}
                  controls
                  onClick={() => {
                    ReactGA.event({
                      category: "start-video",
                      action: "start-video-clicked",
                    });
                  }}
                />
              </Grid>
              {/* </Grid> */}
              {/* <Grid
                item
                xs={12}
                sm={1}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  height: "100%",
                }}
              > */}
              {/* <Box
                  component={"div"}
                  sx={{
                    backgroundColor: "#f26920",
                    color: "#f26920",
                    height: { sm: 250, xs: 2 },
                    width: { sm: 5, xs: "80%" },
                    marginTop: matches ? "0px" : "20px",
                  }}
                ></Box> */}
              {/* </Grid> */}

              <Grid
                item
                xs={12}
                // sm={7}
                md={6}
                // lg={5}
                style={{
                  overflowY: "auto",
                  maxHeight: "30vh",
                  position: "relative",
                  marginTop: isMd ? "10px" : "0px",
                }}
              >
                {/* <Box
                  component="div"
                  sx={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: 54,
                    pointerEvents: "none",
                    background:
                      "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 100%)",
                    // borderBottomLeftRadius: 8,
                    // borderBottomRightRadius: 8,
                  }}
                ></Box> */}
                <Paper
                  style={{
                    // padding: matches ? "20px 5px" : "10px 5px",
                    // opacity: 0.2
                    // background: "grey",
                    marginLeft: !isMd ? "20px" : "0px",
                  }}
                  elevation={0}
                >
                  <Typography
                    variant="h5"
                    style={{
                      fontSize: matches ? "1em" : "0.8em",
                      textAlign: isMd ? "center" : "left",
                    }}
                  >
                    Imagine if we could demonstrate BD in one place, a virtual
                    version of our safety and innovation hub, in the palm of
                    your hands. <br />
                    <br />
                    With Virtual BD, you can explore all our departments, and
                    show how our solutions connect across the patient journey
                    for all care settings. <br />
                    <br />
                    Try this short-guided demo we’ve built, and help us shape
                    the next phase of development, by providing feedback on
                    whether you’d like your business unit to be involved. <br />
                    <br />
                    With only 2 rooms, this demo is a small fraction of what
                    we’ll build across a whole series of care settings. The
                    final concept will also be more developed both in visual
                    appearance and functionality including unlimited interaction
                    points and exploration potential.
                  </Typography>
                  {/* <img
                    src={
                      "https://medias3.digi-sim-api.co.uk/virtus-tech/images/70c75d63-e0b9-4b42-a2dd-7d35317a4adf.png"
                    }
                    alt="Part of a bigger Virtual BD"
                    style={{ width: "100%", marginTop: 10 }}
                  /> */}
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Box
                  component={"div"}
                  style={{
                    marginTop: 15,
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                  }}
                >
                  <StartButton />
                </Box>
              </Grid>
            </>
          )}
        </Grid>
      </Container>
    </Box>
  );
}
